import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseLogType } from "../_types/case-log-type";

@Injectable({
    providedIn: 'root',
})
export class CaseLogTypesService extends Service<CaseLogType> {
    public override type = 'caseLogTypes';
    public override url = 'attendance/caseLogTypes';
}
